import React, { useContext, useEffect, useReducer } from 'react';
// import { Grid, Row, Col } from "react-bootstrap";
// import Card from "../../components/Card/Card";
import MainContext from '../../../../store/MainContext';
import API from '../../../../api/axios';
import StripedTable from '../../../../components/Table/StripedTable';
import Loading from '../../../../components/OtherElements/Loading';
import Pagination from '../../../../components/OtherElements/Pagination';
// import { Modal } from "react-bootstrap";
import Grid from '@material-ui/core/Grid';
import Dialog from '../../../../components/Dialog/DefaultDialog';
import { TextField, Button } from '@material-ui/core';
import TwoCards from 'components/Card/TwoCards';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import useRules from '../../../../hooks/useRules';
import useTitle from 'hooks/useTitle';

function Packages(props) {
  useTitle('انواع بسته بندی');
  const main = useContext(MainContext);
  const [rules, hasRule, isAdmin] = useRules();
  const thArray = ['عنوان بسته بندی', 'ویرایش', 'حذف'];
  const itemsCountPerPage = main.state.Props.itemsCountPerPage;
  const initialState = {
    packages: [],
    isLoaded: false,
    fields: {
      title: '',
      search: '',
    },
    select: '',
    mode: 'add',
  };
  // Functions:

  // --- Functions for Reducers:

  function reducer(state, action) {
    const oldFields = state.fields;
    switch (action.type) {
      case 'LOADING':
        return { ...state, isLoaded: false };
      case 'LOADED':
        return { ...state, isLoaded: true };
      case 'PACKAGES':
        return {
          ...state,
          packages: action.payload,
          isLoaded: true,
        };
      case 'CHANGE_FIELDS':
        const value =
          action.payload.type === 'checkbox'
            ? action.payload.checked
            : action.payload.value;
        const name = action.payload.name;
        const fields = state.fields;
        return {
          ...state,
          fields: {
            ...fields,
            [name]: value,
          },
        };
      case 'EDIT_PACKAGE':
        return {
          ...state,
          fields: {
            ...state.fields,
            title: action.payload.title ? action.payload.title : '',
          },
          mode: 'edit',
          select: action.payload._id,
        };
      case 'ADD_PACKAGE':
        return {
          ...state,
          fields: { ...state.fields, title: '' },
          mode: 'add',
          isLoaded: true,
        };
      case 'RESET_FORM':
        return { ...initialState };
      default:
        return { ...state };
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  // -- End of Reducer's functions
  // --- Other Functions :
  function searchQuery(page = 1, limit = itemsCountPerPage, search = '') {
    API(
      `/api/v1/admin/packaging/type/paginate/${page}/${limit}/?search=${search}`,
      {
        method: 'get',
      }
    )
      .then((res) => {
        dispatch({ type: 'PACKAGES', payload: res.data });
      })
      .catch((er) => {
        console.error(er);
      });
  }

  const handleSearch = (e) => {
    handleChangeFields(e);
    searchQuery(1, itemsCountPerPage, e.target.value);
  };
  const handleEditPackage = (packageID) => {
    API(`/api/v1/admin/packaging/type/${packageID}`, {
      method: 'get',
    })
      .then((res) => {
        dispatch({ type: 'EDIT_PACKAGE', payload: res.data });
      })
      .catch((err) => {
        console.error(err);
        props.showMessage(3, 'tl', 'خطا', 'بروز خطا');
      });
  };
  const handlePageChange = (pageNumber) => {
    searchQuery(pageNumber);
  };
  const handleDeletePackage = (id) => {
    API(`/api/v1/admin/packaging/type/${id}`, {
      method: 'delete',
    })
      .then((res) => {
        props.showMessage(2, 'tl', 'حذف', 'با موفقیت حذف گردید.');
        searchQuery();
      })
      .catch((err) => {
        props.showMessage(3, 'tl', 'خطا', 'بروز خطا');
        console.error(err);
      });
  };

  const handleChangeFields = (e) => {
    dispatch({ type: 'CHANGE_FIELDS', payload: e.target });
  };
  const handleSubmitPackage = async () => {
    const errors = {};
    if (state.fields.title === '') {
      errors.title = 'عنوان نباید خالی باشد.';
    }
    const errorArray = [];
    Object.keys(errors).forEach(function (item) {
      errorArray.push(errors[item]);
    });
    if (errorArray.length > 0) {
      props.showMessage(
        3,
        'tl',
        'خطا',
        errorArray.map((e, i) => <li key={i}>{e}</li>)
      );
    } else {
      let l;
      if (state.mode === 'add') {
        l = `/api/v1/admin/packaging/type`;
      } else {
        l = `/api/v1/admin/packaging/type/${state.select}`;
      }
      API(l, {
        method: state.mode === 'add' ? 'post' : 'put',
        data: {
          title: state.fields.title,
        },
      })
        .then((res) => {
          const t = state.mode === 'add' ? 'افزودن' : 'ویرایش';
          const m =
            state.mode === 'add'
              ? 'افزودن با موفقیت انجام شد'
              : 'ویرایش با موفقیت انجام پذیرفت';
          props.showMessage(1, 'tl', t, m);
          dispatch({ type: 'RESET_FORM' });
          searchQuery();
        })
        .catch((err) => {
          props.showMessage(3, 'tl', 'خطا', 'بروز خطا');
          console.error(JSON.stringify(err, null, 2));
        });
    }
  };

  // --- end of functions
  // -- First Render

  useEffect(() => {
    searchQuery();
  }, []);
  // ----

  // --- JSX Variables:
  const packagesTable = state.isLoaded ? (
    <div className="packages-types-table">
      <StripedTable
        thArray={thArray}
        tdArray={state.packages.docs.map((p) => [
          <span>{p.title}</span>,
          <IconButton onClick={() => handleEditPackage(p._id)}>
            <EditIcon />
          </IconButton>,
          hasRule('parameters_packages_can_delete') ? (
            <IconButton onClick={() => handleDeletePackage(p._id)}>
              <DeleteIcon />
            </IconButton>
          ) : (
            ''
          ),
        ])}
      />
      <Pagination
        activePage={state.packages.page}
        itemsCountPerPage={state.packages.limit}
        totalItemsCount={state.packages.totalDocs}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
      />
    </div>
  ) : (
    <Loading text="در حال بارگیری انواع بسته بندی ..." />
  );
  const theForm = (
    <form>
      <Grid container direction="column" alignItems="stretch" spacing={1}>
        <Grid item>
          <TextField
            name="title"
            onChange={handleChangeFields}
            value={state.fields.title}
            label="عنوان بسته بندی"
            variant="outlined"
            fullWidth
          />
        </Grid>

        {state.mode === 'add' ? (
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              size="medium"
              fullWidth
              onClick={handleSubmitPackage}
            >
              افزودن
            </Button>
          </Grid>
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                color="primary"
                variant="contained"
                size="medium"
                fullWidth
                onClick={handleSubmitPackage}
              >
                ویرایش
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                color="default"
                variant="contained"
                size="medium"
                fullWidth
                onClick={() => {
                  dispatch({ type: 'ADD_PACKAGE' });
                }}
              >
                صرفنظر
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
    </form>
  );
  const body = (
    <TwoCards
      title={props.config.name}
      category={
        <TextField
          name="search"
          label="جستجو"
          value={state.fields.search}
          onChange={(e) => handleSearch(e)}
          variant="outlined"
          fullWidth
        />
      }
      secondaryTitle={state.mode === 'add' ? 'افزودن' : 'ویرایش'}
      secondaryCategory="فرم زیر را تکمیل بفرمایید:"
      secondaryContent={theForm}
    >
      <div className="packages">{packagesTable}</div>
    </TwoCards>
  );
  return body;
}
export default Packages;
